import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./theme";
import Navbar from "./components/Navbar/Navbar";
import QuieterMind from "./components/quieterMind";
import Hero from "./components/Hero/Hero";
import BenefitsSection from "./components/benifitsSection";
import WellnessJourneySection from "./components/wellnessJourneySection";
import StoriesSection from "./components/storiesSection";
import FooterSection from "./components/footerSection";
import { LandingPageProvider } from "./context/LandingPageContext";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <LandingPageProvider>
        {/* Premium Navbar */}
        <Navbar />

        {/* Immersive Hero Section */}
        <Hero />

        {/* Quieter Mind Section */}
        <QuieterMind />

        {/* Benefits Section */}
        <BenefitsSection />

        {/* Wellness Journey CTA Section */}
        <WellnessJourneySection />

        {/* Stories Section */}
        <StoriesSection />

        {/* Footer Section */}
        <FooterSection />
      </LandingPageProvider>
    </ThemeProvider>
  );
}

export default App;